import { parseUtmParameter } from './parseUtmParameter';

const COMPARE_FLIGHT_UTM_CAMPAIGN_PREFIX = 'b2c_nov_';
const COMPARE_FLIGHT_UTM_MEDIUMS = ['cpm', 'cpv'];

export function isCompareFlightTooltipShow(url: string | undefined): boolean {
  const utmCampaign = parseUtmParameter(url, 'utm_campaign');
  const utmMedium = parseUtmParameter(url, 'utm_medium');

  return (
    (utmCampaign?.startsWith(COMPARE_FLIGHT_UTM_CAMPAIGN_PREFIX) ?? false) &&
    utmMedium !== null &&
    COMPARE_FLIGHT_UTM_MEDIUMS.includes(utmMedium)
  );
}
